import React, { type ReactNode, type MouseEvent } from 'react';
import { styled } from '@compiled/react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { LoadingButton } from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

type Props = {
	isDisabled: boolean;
	isLoading: boolean;
	numberToLoad: number;
	children: ReactNode;
	onClick: (event: MouseEvent, analyticsEvent: UIAnalyticsEvent) => void;
	loadButton?: boolean; // use as an alternative to numberToLoad if needed
};

const LoadMoreButton = ({
	onClick,
	isDisabled,
	isLoading,
	numberToLoad,
	children,
	loadButton,
}: Props) => {
	if (numberToLoad <= 0 && !loadButton) {
		return null;
	}

	return (
		<LoadMoreButtonContainer>
			<LoadingButton
				onClick={onClick}
				isDisabled={isDisabled}
				isLoading={isLoading}
				shouldFitContainer
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				testId="issue.activity.common.component.load-more-button.loading-button"
				interactionName="auto-generated.issue.activity.common.component.load-more-button.loading-button.button"
			>
				{children}
			</LoadingButton>
		</LoadMoreButtonContainer>
	);
};

export default LoadMoreButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LoadMoreButtonContainer = styled.div({
	marginTop: token('space.200'),
	marginRight: 0,
	marginBottom: token('space.200'),
	marginLeft: 0,
});
LoadMoreButtonContainer.displayName = 'LoadMoreButtonContainer';
